/* jshint esversion: 6 */
/* jshint ignore:start */
import SaidMenu from './SaidMenu';
import { Outlet} from 'react-router-dom';

const Dashboard = () => {
    return (
        <div className='width-container'>
            <div className="">
                <div className="saidmenu scroll-container">
                    <SaidMenu />
                </div>
                <div className="margin">
                    <Outlet />
                </div>
            </div>

        </div>
    )
}

export default Dashboard
/* jshint ignore:end */